module.exports = __webpack_public_path__ + "img/név.f9d98b1f.png";